import React from 'react';
import styles from './HeroSection.module.css';

interface HeroSectionProps {
  boldText: string;
  mainText?: string;
  className?: string;
}

const HeroSection: React.FC<HeroSectionProps> = ({ boldText, mainText, className }) => {
  return (
    <section className={`${styles.hero} ${className || ''}`}>
      <div className={styles.heroContainer}>
        <div className={styles.heroContent}>
          <h1 className={styles.heroTitle}>
            Professional resumes
            <span className={styles.gradientText}> that make an impression.</span>
          </h1>
          <p className={styles.heroSubtitle}>
            <b>{boldText}</b>{mainText && ` ${mainText}`}
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
